import clsx from 'clsx'
import React, { useId, useMemo } from 'react'

import { InputBlockContext } from './context'
import { InputBlockInput } from './Input'
import { InputBlockRow } from './Row'
import { InputBlockSelect } from './Select'

export interface InputBlockProps extends Omit<React.FieldsetHTMLAttributes<HTMLFieldSetElement>, 'className'> {
  children: React.ReactNode;
  description?: React.ReactNode;
  label?: React.ReactNode;
  sublabel?: React.ReactNode;
}

export function InputBlock ({ children, description, label, sublabel, ...props }: InputBlockProps) {
  const descriptionId = useId()
  const portalId = useId()
  const sublabelId = useId()

  const contextValue = useMemo(() => ({ portalId }), [portalId])

  const describedBy = useMemo(() => {
    return [
      description ? descriptionId : undefined,
      sublabel ? sublabelId : undefined,
    ].filter(Boolean).join(' ')
  }, [description, sublabel])

  return (
    <div>
      <fieldset
        {...props}
        aria-describedby={describedBy}
      >
        {!!label && (
          <>
            <legend
              className={clsx('body-sm-bold text-gray-800 block', {
                'mb-2': !sublabel,
              })}
            >
              {label}
            </legend>
            {sublabel && (
              <div id={sublabelId} className='body-sm text-gray-500 mb-2'>
                {sublabel}
              </div>
            )}
          </>
        )}
        <div className={clsx('flex flex-col', 'rounded-lg')}>
          <InputBlockContext.Provider value={contextValue}>
            {children}
          </InputBlockContext.Provider>
        </div>
      </fieldset>
      <div id={portalId} />
      {!!description && (
        <div id={descriptionId} className='body-sm text-gray-500 mt-2'>
          {description}
        </div>
      )}
    </div>
  )
}

InputBlock.Input = InputBlockInput
InputBlock.Row = InputBlockRow
InputBlock.Select = InputBlockSelect
